// Utility to detect online/offline status and show notifications
import { processPendingRequests, getPendingCount } from './offlineQueue';
import { apiRequest } from '../redux/Action/apiRequest';
import { setSyncing, setLastSyncAt, setPendingCount } from '../redux/Slices/sync.slice';

export class OfflineDetector {
  constructor() {
    this.isOnline = navigator.onLine;
    this.listeners = [];
    this.dispatch = null;
    this.setupListeners();
  }

  setDispatch(dispatch) {
    this.dispatch = dispatch;
  }

  setupListeners() {
    window.addEventListener('online', async () => {
      this.isOnline = true;
      this.notifyListeners(true);
      console.log('[Offline Detector] Connection restored');

      if (this.dispatch) {
        setTimeout(async () => {
          try {
            this.dispatch(setSyncing(true));
            const results = await processPendingRequests(this.dispatch, apiRequest);
            this.dispatch(setLastSyncAt(Date.now()));
            const count = await getPendingCount();
            this.dispatch(setPendingCount(count));
            if (results.processed > 0) {
              console.log(`[Offline Detector] Processed ${results.processed} queued requests`);
            }
          } catch (error) {
            console.error('[Offline Detector] Error processing pending requests:', error);
          } finally {
            this.dispatch(setSyncing(false));
          }
        }, 1000);
      }
    });

    window.addEventListener('offline', () => {
      this.isOnline = false;
      this.notifyListeners(false);
      console.log('[Offline Detector] Connection lost - App is now offline');
    });
  }

  onStatusChange(callback) {
    this.listeners.push(callback);
    // Call immediately with current status
    callback(this.isOnline);
  }

  removeListener(callback) {
    this.listeners = this.listeners.filter(listener => listener !== callback);
  }

  notifyListeners(isOnline) {
    this.listeners.forEach(callback => callback(isOnline));
  }

  getStatus() {
    return this.isOnline;
  }
}

// Export singleton instance
export const offlineDetector = new OfflineDetector();

